import { signin, signout, resign, me, challenge, verify, changePassword, toggleIsEnabledAd } from '@/api/auth'
import store from '@/store'

const user = {
  state: {
    id: null,
    name: '',
    email: '',
    level: null,
    ticket: null,
    ticket_expires_at: null,
    is_enabled_ad: null,
  },

  mutations: {
    SET_ID: (state, id) => {
      state.id = id
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_EMAIL: (state, email) => {
      state.email = email
    },
    SET_LEVEL: (state, level) => {
      state.level = level
    },
    SET_TICKET: (state, ticket) => {
      state.ticket = ticket
    },
    SET_TICKET_EXPIRES_AT: (state, ticket_expires_at) => {
      state.ticket_expires_at = ticket_expires_at
    },
    SET_IS_ENABLED_AD: (state, is_enabled_ad) => {
      state.is_enabled_ad = is_enabled_ad
    },
  },

  actions: {
    // 登录
    authSignin({ commit }, userInfo) {
      const email = userInfo.email.trim()
      return new Promise((resolve, reject) => {
        signin(email, userInfo.password).then(response => {
          commit('SET_EMAIL', email)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    authMe({ commit, state }) {
      return new Promise((resolve, reject) => {
        me().then(response => {
          const data = response.data
          commit('SET_ID', data.id)
          commit('SET_EMAIL', data.email)
          commit('SET_NAME', data.last_name + ' ' + data.first_name)
          commit('SET_LEVEL', data.level)
          commit('SET_TICKET', data.ticket)
          commit('SET_TICKET_EXPIRES_AT', data.ticket_expires_at)
          commit('SET_IS_ENABLED_AD', data.is_enabled_ad)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    authSignout({ commit, state }) {
      return new Promise((resolve, reject) => {
        signout().then(response => {
          commit('SET_ID', '')
          commit('SET_EMAIL', '')
          commit('SET_NAME', '')
          commit('SET_LEVEL', '')
          commit('SET_TICKET', '')
          commit('SET_TICKET_EXPIRES_AT', '')
          commit('SET_IS_ENABLED_AD', '')
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    authResign({ commit }) {
      return new Promise((resolve, reject) => {
        resign().then(response => {
          commit('SET_ID', '')
          commit('SET_EMAIL', '')
          commit('SET_NAME', '')
          commit('SET_LEVEL', '')
          commit('SET_TICKET', '')
          commit('SET_TICKET_EXPIRES_AT', '')
          commit('SET_IS_ENABLED_AD', '')
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 再発行申請
    authForgetPassword({ commit }, userInfo) {
      userInfo.onetimepasswordType = 'forget-password'
      return new Promise((resolve, reject) => {
        challenge(userInfo).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 再発行申請
    authChangeEmail({ commit }, userInfo) {
      userInfo.onetimepasswordType = 'change-email'
      return new Promise((resolve, reject) => {
        challenge(userInfo).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 再発行申請
    authVerify({ commit }) {
      let params = new URLSearchParams(location.search)

      const email = params.get('email')
      const onetimepassword = params.get('onetimepassword')

      return new Promise((resolve, reject) => {
        if (!email || !onetimepassword) {
          resolve()
        } else {
          verify({
            email: email,
            onetimepassword: onetimepassword
          }).then(response => {
            commit('SET_EMAIL', email)
            resolve(response)
          }).catch(error => {
            reject(error)
          })
        }
      })
    },

    // 再発行申請
    authReset({ commit }, userInfo) {
      const email = userInfo.email.trim()
      const password = userInfo.password
      const onetimepassword = userInfo.onetimepassword
      return new Promise((resolve, reject) => {
        reset(email, password, onetimepassword).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 再発行申請
    authChangePassword({ commit }, userInfo) {
      const password = userInfo.password
      return new Promise((resolve, reject) => {
        changePassword(password).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    authToggleIsEnabledAd({ commit }, is_enabled_ad) {
      return new Promise((resolve, reject) => {
        toggleIsEnabledAd(is_enabled_ad).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
  }
}

export default user
